<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main>
          <div class="mainTitle">
            <h3>操作日志</h3>
            <p>记录对数据的操作，方便找回</p>
          </div>

          <div class="mainBody">
            <el-table :data="tableData" style="width: 100%" :cell-class-name="addClass">
              <el-table-column prop="index" label="序号" min-width="1"></el-table-column>
              <el-table-column prop="typeCn" label="操作类型" min-width="2"></el-table-column>
              <el-table-column prop="name_cn" label="操作对象" min-width="2"></el-table-column>
              <el-table-column prop="record_content" label="操作描述" min-width="8" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p @click="toResultDetail(scope.$index)" v-bind:class="[showDetail(tableData[scope.$index].type) ? 'resAndSug_' : 'resAndSug']">
                    {{ scope.row.record_content }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="resultS" label="执行结果" min-width="3"></el-table-column>
              <el-table-column prop="recorder" label="操作人" min-width="2"></el-table-column>
              <el-table-column prop="record_time" label="操作时间" min-width="3"></el-table-column>
              <el-table-column prop="reset" label="还原" min-width="2" align="center">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="backOff(scope.$index)" type="primary" size="small" v-if="tableData[scope.$index].is_restore == 0">还原</el-button>
                  <el-button v-else type="button" size="small" disabled>已还原</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="elPaginationDiv">
              <el-pagination class="elPagination" background layout="prev, pager, next" :page-size="pageMaxSize" :page-count="pageCount" @current-change="currentChange"></el-pagination>
              <span class="paginationPageNum">第{{ thispageNum }}条，总共{{ recordCount }}条</span>
            </div>
          </div>
        </el-main>
        <op-log-drawer ref="_opLogDrawer" @toBackOff="backOff"></op-log-drawer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import { isEmpty } from '@/utils/strUtils'
import leftMeun from '@/components/layout/leftMeun'
import headerLayout from '@/components/layout/headerLayout'
import opLogDrawer from '@/components/drawer/opLogDrawer'

export default {
  components: {
    leftMeun,
    headerLayout,
    opLogDrawer
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '操作日志',
      tableData: [],
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0,
      dataListPageIndex: 1,
      recordCount: 0,
      thispageNum: '1-' + LIST_PAGE_MAX_SIZE
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getOpLog()
    },
    addClass(row, column, rowIndex, columnIndex) {
      // if(columnIndex==3){
      //   return 'resAndSug';
      // }
    },
    currentChange(val) {
      this.dataListPageIndex = val
      this.getOpLog()
    },
    // 获取操作日志列表
    getOpLog() {
      this.$api
        .getOpLog({
          token: localStorage.getItem('token'),
          page: this.dataListPageIndex,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          this.recordCount = data.Data.recordCount
          var currentPage = data.Data.currentPage
          var startIndex = (currentPage - 1) * this.pageMaxSize + 1
          var endIndex = startIndex + this.pageMaxSize - 1
          if (endIndex > this.recordCount) {
            endIndex = this.recordCount
          }
          this.thispageNum = startIndex + '-' + endIndex
          this.tableData = data.Data.model
          this.pageCount = data.Data.pageCount

          var index = 1
          this.tableData.forEach(element => {
            element.index = index++ + this.pageMaxSize * (this.dataListPageIndex - 1)
            var content = ''
            if (!isEmpty(element.record_content)) {
              element.record_content.forEach(msg => {
                if (isEmpty(content)) {
                  content = msg
                } else {
                  content += '\n' + msg
                }
              })
            }
            element.record_content = content + '\n'
            console.log(content)
          })
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    // 日志还原
    backOff(index) {
      var row = this.tableData[index]
      var type = row.type
      if (type == 1 || type == 2) {
        this.$api
          .logBackOff({
            token: localStorage.getItem('token'),
            back_id: row.id
          })
          .then(({ data }) => {
            console.log(data)
            if (data.Code == 0) {
              // row.is_restore = 1;
              this.getOpLog()
            } else {
              this.$message.error(data.Msg)
            }
          })
          .catch(({ error }) => {
            console.log(error)
          })
      } else if (this.showDetail(type)) {
        this.$api
          .backOffImportLog({
            token: localStorage.getItem('token'),
            recordLogId: row.id
          })
          .then(({ data }) => {
            console.log(data)
            if (data.Code == 0) {
              // row.is_restore = 1;
              this.getOpLog()
            } else {
              this.$message.error(data.Msg)
            }
          })
          .catch(({ error }) => {
            console.log(error)
          })
      }
    },
    toResultDetail(index) {
      var row = this.tableData[index]
      var type = row.type
      var title = row.record_content
      var id = row.id
      if (this.showDetail(type)) {
        this.$nextTick(() => {
          this.$refs._opLogDrawer.show(row, index)
        })
      }
    },
    // 是否可查看日志详情
    showDetail(type) {
      if (type == 3 || type == 4 || type == 5 || type == 6) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.resAndSug {
  white-space: pre-line;
  line-height: 23px;
}
.resAndSug_ {
  cursor: pointer;
  white-space: pre-line;
  line-height: 23px;
  color: #478ce9;
}
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 10px 20px;
}
.mainBody {
  margin-top: 10px;
  padding: 20px 30px 15px 20px;
  background-color: #ffffff;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/opLog.vue